export const Footer =()=>{
    return(
        <>
            <div className="row mt-4 m-0 rounded_eic">
                <div className="col-12 ">
                    <p className="bg-white py-3 px-4 pt-3 rounded_eic">© 2025 Copyright CDAT. All Rights Reserved.</p>
                </div>
            </div>
        </>
    )
}